import { render, staticRenderFns } from "./SolicitudesHistoricasTable.html?vue&type=template&id=48dcbf16&external"
import script from "./SolicitudesHistoricasTable.vue?vue&type=script&lang=js"
export * from "./SolicitudesHistoricasTable.vue?vue&type=script&lang=js"
import style0 from "./SolicitudesHistoricasTable.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports